import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {environment} from 'environment';

import {Category} from 'shared/models/target-groups/category';

@Injectable()
export class CategoriesRepository {

  constructor(private http: Http) { }

  public getAllCategories(): Observable<Array<Category>> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.categories}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public getCategory(id: String): Observable<Category> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.get(`${environment.targetGroups.categories}/${id}`, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public createCategory(category: Category): Observable<Category> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(category);

    return this.http.post(`${environment.targetGroups.categories}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public updateCategory(category: Category): Observable<Category> {
    const headers: Headers = new Headers({'Content-Type': 'application/json'});
    const options: RequestOptions = new RequestOptions({headers: headers, withCredentials: true});
    const body: String = JSON.stringify(category);

    return this.http.put(`${environment.targetGroups.categories}/${category._id}`, body, options)
      .map((response: Response) => {
        return response.json();
      });
  }

  public deleteCategory(category: Category): Observable<boolean> {
    const options: RequestOptions = new RequestOptions({withCredentials: true});

    return this.http.delete(`${environment.targetGroups.categories}/${category._id}`, options)
      .map((response: Response) => {
        return response.ok;
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/categories/repositories/categories.repository.ts